// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ogl7QmhUY0TyIdvN3Au4{align-items:center;height:16px;margin:0 -4px;display:flex}.ogl7QmhUY0TyIdvN3Au4.ZgRZlXfPjq0Yc51_ySPv{display:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"clearAction": `ogl7QmhUY0TyIdvN3Au4`,
	"hidden": `ZgRZlXfPjq0Yc51_ySPv`
};
export default ___CSS_LOADER_EXPORT___;
